import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch, Glitch_SearchRequest } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy, GlitchSearch_GroupBy } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { JobSearchResult } from '../JobSearchResult/JobSearchResult';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'GlitchSearchGroup',
    templateUrl: './GlitchSearchGroup.html'
})

export class GlitchSearchGroup extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('jobSearchResult') jobSearchResult: JobSearchResult;
    _Model: any;
    _RequestModel: Glitch_SearchRequest;
    DateFormat: string;
    Selected: any;
    ShowGroup: boolean = false;
    ChildInit: boolean = false;

    Rows_Add: number = 0;
    Rows_Update: number = 0;
    Rows_LastHandled: Array<number> = [];

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        //this.complainService.ComplainRowChanged.pipe(untilDestroyed(this)).subscribe((data) => {
        //    this.onComplainRowChanged(data);
        //});

        //this.complainService.ComplainRowAdded.pipe(untilDestroyed(this)).subscribe((data) => {
        //    this.onComplainRowAdded(data);
        //});
    }

    @Input("Model") set Model(Model: any) {
        this._Model = Model;
        this.SetRequestModel();
    }

    get Model() :any {
        return this._Model;
    }

    @Input("RequestModel") set RequestModel(value: Glitch_SearchRequest) {
        this._RequestModel = _.cloneDeep(value);
        this.SetRequestModel();
    }

    get RequestModel(): Glitch_SearchRequest {
        return this._RequestModel;
    }

    SetRequestModel(): void {
        if (this._Model == null || this.RequestModel == null) {
            return;
        }

        let req = this._RequestModel;

        if (req.GroupBy == GlitchSearch_GroupBy.None)
            return;

        switch (req.GroupBy) {            
            case GlitchSearch_GroupBy.GlitchCategories:
                req.GlitchCategories = [this._Model.Id];
                break;
            case GlitchSearch_GroupBy.GlitchDescriptionMaster:
                req.GlitchDescriptions = [this._Model.Id];
                break;
            case GlitchSearch_GroupBy.Dept:
                req.Departments = [this._Model.Id];
                break;
            case GlitchSearch_GroupBy.Location:
                req.Locations = [this._Model.Id];
                break;            
            case GlitchSearch_GroupBy.Property:
                req.Properties = [this._Model.Id];
                break;
        }

        req.GroupBy = GlitchSearch_GroupBy.None;
        req.PageNumber = 1;
        req.PageSize = 10;

        //console.info(this._RequestModel);
    }

    onToggle(): void {
        this.ShowGroup = !this.ShowGroup;
        if (this.ChildInit)
            return;

        this.jobSearchResult.Show();
        this.ChildInit = true;
    }

    isFilterMatch(data: any): boolean {
        let m = true;
        if (this.RequestModel.GlitchCategories != null && this.RequestModel.GlitchCategories.length > 0) {
            if (this.RequestModel.GlitchCategories.findIndex(a => a == data.CategoryId) < 0)
                return false;
        }

        if (this.RequestModel.GlitchDescriptions != null && this.RequestModel.GlitchDescriptions.length > 0) {
            if (this.RequestModel.GlitchDescriptions.findIndex(a => a == data.GlitchDescriptions) < 0)
                return false;
        }

        if (this.RequestModel.Departments != null && this.RequestModel.Departments.length > 0) {
            if (this.RequestModel.Departments.findIndex(a => a == data.DeptId) < 0)
                return false;
        }

        if (this.RequestModel.Locations != null && this.RequestModel.Locations.length > 0) {
            if (this.RequestModel.Locations.findIndex(a => a == data.LocationId) < 0)
                return false;
        }

        if (this.RequestModel.Properties != null && this.RequestModel.Properties.length > 0) {
            if (this.RequestModel.Properties.findIndex(a => a == data.PropertyId) < 0)
                return false;
        }
        return m;
    }

    onComplainRowAdded(data: any): void {
        //console.info(data);

        if (this.isFilterMatch(data) == false) {
            return;
        }

        if (this.Rows_LastHandled.findIndex(a => a == data.ComplainId) < 0) {
            this.Rows_Add = this.Rows_Add + 1;
            this.Rows_LastHandled.push(data.ComplainId);
        }
    }

    onComplainRowChanged(data: any): void {
        if (this.isFilterMatch(data) == false) {
            return;
        }

        if (this.Rows_LastHandled.findIndex(a => a == data.ComplainId) < 0) {
            this.Rows_Update = this.Rows_Update + 1;
            this.Rows_LastHandled.push(data.ComplainId);
        }
    }

    onResultRefresh(): void {
        this.Rows_Add = 0;
        this.Rows_Update = 0;
    }
}
